import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { AwsAccesses } from "./accesses.ts";
import { AwsComponents } from "./components.ts";
import { AwsIconUrl } from "./icon.ts";

const AwsFilters = {
  account: { keys: ["id"] },
  group: { keys: ["name"] },
  "permission-set": { keys: ["arn", "name"], labeler: { arn: "ARN" } },
  policy: { keys: ["arn"], labeler: { arn: "ARN" } },
  resource: { keys: ["arn", "name", "service"], labeler: { arn: "ARN" } },
  role: { keys: ["name"] },
  tag: { keys: "string" },
} as const satisfies AnyFilterSchema;

export type AwsFilters = typeof AwsFilters;

export const AwsRegistration = Registration({
  accesses: AwsAccesses,
  category: "resource",
  components: AwsComponents,
  docs: { install: "aws", request: "aws/requesting-access" },
  filters: AwsFilters,
  identifier: (key) => (key === "function-caller" ? "ARN" : "identifier"),
  itemKind: (key) =>
    key === "function-caller"
      ? "lambda"
      : key === "rds-security-perimeter"
        ? "security perimeter"
        : "account",
  label: "Amazon Web Services",
  logoUrl: AwsIconUrl,
  maturity: "ga",
  requestType: "requestable",
  useMapping: [
    { use: "iam_write", component: "iam-write" },
    { use: "iam_read", component: "iam-assessment" },
    { use: "function-caller", component: "function-caller" },
    { use: "access_logs", component: "access-logs" },
  ],
});

registerIntegration("aws", AwsRegistration);
